import { computed, ref, toRaw, watch } from 'vue'

import axios from 'axios'

const user_profiles = ref([])
const filtered_user_profiles = ref([])
const user_profile_filters = ref({
  name: '',
})

export default function useUserProfiles() {
  const listUserProfiles = async () => {
    await axios
      .get('/api/user_profiles/all')
      .then(function (response) {
        user_profiles.value = filtered_user_profiles.value = response.data.data
      })
      .catch(function () {})
  }

  const updateFilters = async () => {
    let filters = toRaw(user_profile_filters.value)

    filtered_user_profiles.value = user_profiles.value.filter((row) => {
      let user_profile = toRaw(row)
      let matches = 0

      for (let key of Object.keys(filters)) {
        if (filters[key].toString().trim() == '') {
          matches++
          continue
        }

        if (
          user_profile[key]
            .toString()
            .trim()
            .toLowerCase()
            .normalize('NFD')
            .replace(new RegExp(/[\u0300-\u036f]/, 'gi'), '')
            .includes(
              filters[key]
                .toString()
                .trim()
                .toLowerCase()
                .normalize('NFD')
                .replace(new RegExp(/[\u0300-\u036f]/, 'gi'), ''),
            )
        ) {
          matches++
        }
      }

      return matches == Object.keys(filters).length
    })
  }

  watch(user_profile_filters.value, () => {
    setTimeout(() => {
      updateFilters()
    }, 250)
  })

  return {
    user_profiles: computed(() => user_profiles.value),
    filtered_user_profiles: computed(() => filtered_user_profiles.value),
    user_profile_filters,
    listUserProfiles,
  }
}
